// Reusable higher order reducer, lifted from:
// https://redux.js.org/recipes/structuring-reducers/refactoring-reducers-example
// If a reducer has too much case logic, this pattern is used to pull cases
// into their own reducers.
export default (initialState, handlers) => {
  return (state = initialState, action) => {
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
};
